const getEnv = 'PRODUCTION';
// const getEnv = 'QA';
// const getEnv = 'PRODUCTION';

const store = 'bump';
// const store = 'bitsy';
// const store = 'wtebump';
// const store = 'pnmbump';

const getGoogleOptimizeId = {
  wtebump: 'GTM-PZPMRDB',
  pnmbump: null,
  bitsy: 'OPT-P7H9DQB',
  bump: 'GTM-W7BNX5Q',
};

const getGoogleAdWordsId = {
  wtebump: 'AW-969327984',
  pnmbump: 'AW-969327984',
  bitsy: 'AW-803829201',
  bump: 'AW-969327984',
};

const getGoogleAdWordsIdAndProperty = {
  wtebump: 'AW-969327984/el02CKW3pnMQ8IqbzgM',
  pnmbump: 'AW-969327984/el02CKW3pnMQ8IqbzgM',
  bitsy: 'AW-803829201/fX3xCJXM8IIBENHrpf8C',
  bump: 'AW-969327984/el02CKW3pnMQ8IqbzgM',
};

let getGoogleAnalyticsTrackingId = {
  wtebump: 'UA-134509754-1',
  pnmbump: 'UA-136887062-1',
  bitsy: 'UA-118644809-1',
  bump: 'UA-49488496-1',
};
if (getEnv !== 'PRODUCTION') {
  getGoogleAnalyticsTrackingId = {
    wtebump: 'UA-49488496-3',
    pnmbump: 'UA-49488496-3',
    bitsy: 'UA-49488496-3',
    bump: 'UA-49488496-3',
  };
}

const getGTMId = {
  wtebump: 'GTM-PSLL274',
  pnmbump: 'GTM-PKF5FQ',
  bitsy: 'GTM-5K3BKKW',
  bump: 'GTM-PKF5FQ',
};

const getFacebookPixelId = {
  wtebump: '1506270289506684',
  pnmbump: '1061159043910150',
  bitsy: '181961985795589',
  bump: '1061159043910150',
};

const getStripePublicAPIKey = {
  bump: {
    DEVELOPMENT: 'pk_test_ECwJYpjwrPGLxb0hlooiZebE00x4wE2loE',
    QA: 'pk_test_ECwJYpjwrPGLxb0hlooiZebE00x4wE2loE',
    PRODUCTION: 'pk_live_mq1fdZqt6v91Nmlyup6CTdXP',
  },
  bitsy: {
    DEVELOPMENT: 'pk_test_ECwJYpjwrPGLxb0hlooiZebE00x4wE2loE',
    QA: 'pk_test_ECwJYpjwrPGLxb0hlooiZebE00x4wE2loE',
    PRODUCTION: 'pk_live_mq1fdZqt6v91Nmlyup6CTdXP',
  },
  wtebump: {
    DEVELOPMENT: 'pk_test_fY4zE2SqrYJKTNnhv2FwF8w8',
    QA: 'pk_test_fY4zE2SqrYJKTNnhv2FwF8w8',
    PRODUCTION: 'pk_live_J1OYKxMcsBrtnAQRDeEoztup',
  },
  pnmbump: {
    DEVELOPMENT: 'pk_test_v7CyNHC2FWl0u2eiDHlTy85W00WqY1u8RV',
    QA: 'pk_test_v7CyNHC2FWl0u2eiDHlTy85W00WqY1u8RV',
    PRODUCTION: 'pk_live_GguPOq14MSKef00NF47H6oTW00G5h1DDUD',
  },
};

const getStripeApiVersion = {
  DEVELOPMENT: '2020-08-27',
  QA: '2018-02-28',
  PRODUCTION: '2018-02-28',
};

const selfDomainMap = {
  bitsy: {
    DEVELOPMENT: 'http://localhost:3000',
    QA: 'https://bitsy.bumptesting.com',
    PRODUCTION: 'https://bitsyboxes.com',
  },
  bump: {
    DEVELOPMENT: 'http://localhost:3000',
    QA: 'https://bump.bumptesting.com',
    PRODUCTION: 'https://bumpboxes.com',
  },
  wtebump: {
    DEVELOPMENT: 'http://localhost:3000',
    QA: 'https://wte.bumptesting.com',
    PRODUCTION: 'https://whattoexpect.bumpboxes.com',
  },
  pnmbump: {
    DEVELOPMENT: 'http://localhost:3000',
    QA: 'https://pnm.bumptesting.com',
    PRODUCTION: 'https://pnmag.bumpboxes.com',
  },
};

const adminDomain = {
  DEVELOPMENT: 'http://localhost:3001',
  QA: 'https://admin.bumptesting.com',
  PRODUCTION: 'https://administrator.bitsyboxes.com',
};

const domainWithoutGraphQL = {
  DEVELOPMENT: 'http://localhost:4000',
  QA: 'https://qa.bitsyboxes.co',
  PRODUCTION: 'https://prod.bitsyboxes.co',
};

const domain = {
  DEVELOPMENT: 'http://localhost:4000/graphql',
  QA: 'https://qa.bitsyboxes.co/graphql',
  PRODUCTION: 'https://prod.bitsyboxes.co/graphql',
};

module.exports = {
  getEnv,
  store,
  getGoogleAnalyticsTrackingId: getGoogleAnalyticsTrackingId[store],
  getStripePublicAPIKey: getStripePublicAPIKey[store][getEnv],
  getStripeApiVersion: getStripeApiVersion[getEnv],
  getSelfDomain: selfDomainMap[store][getEnv],
  getDomain: domain[getEnv],
  getAdminDomain: adminDomain[getEnv],
  domainWithoutGraphQL: domainWithoutGraphQL[getEnv],
  getGTMId: getGTMId[store],
  getFacebookPixelId: getFacebookPixelId[store],
  getGoogleAdWordsId: getGoogleAdWordsId[store],
  getGoogleAdWordsIdAndProperty: getGoogleAdWordsIdAndProperty[store],
  getGoogleOptimizeId: getGoogleOptimizeId[store],
};
